import cn from 'classnames';
import { arrayToggle } from 'common/ArrayUtilities';
import { QueryParams } from 'common/urls/QueryParams';
import { TagFilter } from 'src/gqlReactTypings.generated.d';
import { useCachedDishFirstFilters } from 'src/pages/consumer/dish-first/explore/hooks';
import { Toggle } from 'src/shared/design-system/Toggle';
import { TopShefShefHatIcon } from './Icons';

export const TopShefFilterButton = ({ className }: { className?: string }) => {
  const {
    filters: { tagFilters, updateQueryParams },
  } = useCachedDishFirstFilters();
  const enabled = tagFilters.includes(TagFilter.TopShef);

  const handleClick = () => {
    const nextTagFilters = arrayToggle<TagFilter>(tagFilters, TagFilter.TopShef);
    updateQueryParams({ [QueryParams.TAG_FILTER]: nextTagFilters }, 'replaceIn');
  };

  return (
    <div className={cn(className, 'flex-0 flex items-center')}>
      <TopShefShefHatIcon className='mr-2 w-5 text-raspberry' />
      <div className='mr-2 text-base md:text-lg'>Top Shef</div>
      <Toggle checked={enabled} onChange={handleClick} />
    </div>
  );
};

export const TopShefFilterButtonDivider = ({ className }: { className?: string }) => (
  <div className={cn(className, 'h-7 w-px bg-neutral-100')} />
);
